const map = {
	"./ax.png": [
		3581,
		[
			581
		]
	],
	"./b2b.png": [
		5562,
		[
			562
		]
	],
	"./bc.png": [
		9227,
		[
			227
		]
	],
	"./bigcommerce.png": [
		3603,
		[
			603
		]
	],
	"./crm.png": [
		9640,
		[
			640
		]
	],
	"./ege.png": [
		593,
		[
			593
		]
	],
	"./f&o.png": [
		6391,
		[
			391
		]
	],
	"./gp.png": [
		2807,
		[
			807
		]
	],
	"./imagerelay.png": [
		9536,
		[
			536
		]
	],
	"./magento.png": [
		5667,
		[
			667
		]
	],
	"./marketplace.png": [
		6969,
		[
			969
		]
	],
	"./nav.png": [
		4479,
		[
			479
		]
	],
	"./netsuite.png": [
		1045,
		[
			45
		]
	],
	"./oms.png": [
		587,
		[
			587
		]
	],
	"./pimcore.png": [
		3175,
		[
			175
		]
	],
	"./sage.png": [
		1050,
		[
			50
		]
	],
	"./sap.png": [
		2600,
		[
			600
		]
	],
	"./sfcc.png": [
		2403,
		[
			403
		]
	],
	"./shopify.png": [
		1174,
		[
			174
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6084;
module.exports = webpackAsyncContext;